import { type FC } from 'react';

import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { RatingBox } from '@vakantiesnl/components/src/molecules/RatingBox';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';

import { usCustomStyles } from './RatingSubscores.style';

export interface RatingSubscoresProps {
	/** Rating subscores with labels */
	subscores: { rating: number; label: string }[];
	/** Classname for the component container */
	className?: string;
}

export const RatingSubscores: FC<RatingSubscoresProps> = ({ subscores }) => {
	const { classes } = usCustomStyles();
	const microCopies = useMicroCopyContext();

	return (
		<div data-qa="subscores">
			<ul className={classes.wrapper}>
				{subscores.map((subscore) => (
					<RatingBox
						key={subscore.label}
						size="small"
						label={false}
						rating={subscore.rating}
						component="li"
						className={classes.ratingBox}
					>
						<Typography variant="headingXs" as="h6" className={classes.title}>
							{microCopies[`scoreRating.aspects.${subscore.label}`]}
						</Typography>
					</RatingBox>
				))}
			</ul>
		</div>
	);
};
